// extracted by mini-css-extract-plugin
export default {"treeselect":"DocumentEditPopup_treeselect_bW_IX","uploader":"DocumentEditPopup_uploader_EA1eZ","upload-btn":"DocumentEditPopup_upload-btn_uysep"};